import { BaseDynamicZoneModel } from "@models/dynamic-zones";
import { OneTileDynamicZoneModel } from "./tile-wrapper";

export enum TreeWithThreeTilesVariant {
  WITH_BRANCH = "withBranches",
  WITHOUT_BRANCH = "withoutBranches",
}
export interface TreeWithThreeTilesDynamicZoneModel
  extends BaseDynamicZoneModel {
  tiles: OneTileDynamicZoneModel[];
  divColor: string | null;
  variant: TreeWithThreeTilesVariant;
}
